module.exports = __webpack_public_path__ + "img/1724249191287-IMG_1521.jpeg.6e0dd019.webp";